import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import { iWAMarketingCampaign } from "@sdk/wa-marketing-campaigns/wa-marketing-campaigns-model";
import React from "react";

const AddWACampaignModal = React.lazy(() => import("./add-wa-campaign.modal"));

const AddWACampaign: iModalProps<
  typeof AddWACampaignModal,
  {
    onCreated?: (content: iWAMarketingCampaign) => any;
  }
> = {
  name: "add-wa-marketing-campaign",
  component: GenerateModalWithSuspense(AddWACampaignModal),
};

export default AddWACampaign;
